<template>
    <div class="main">
        <div class="TriangleTop">
            <div class="TriangleVerticalTop">
                <div class="logo-container">
                    <img class="logo" src="../assets/logo_wTVision_white.png" alt="Logo">
                </div>
            </div>
            <div class="TriangleVerticalLine"></div>
        </div>
        <div class="BottomContainer">
            <div class="user-area">
                <div v-if="!isAuthenticated" class="login">
                    <input id="email" name="email" v-model="email" placeholder="Email" required />
                    <input id="password" name="password" v-model="password" placeholder="Password" required type="password" />
                </div>                
                <img v-if="isAdmin" src="../assets/admin.png" alt="" title="Administrator Dashboard" @click="navToAdmin">
                <img v-if="!isAuthenticated" src="../assets/login.png" alt="" title="Login" @click="login">
                <label v-if="!isAuthenticated" class="or-style">OR</label>
                <img v-if="!isAuthenticated" src="../assets/register.png" alt="" title="Create new user" @click="navToRegister">
                <img v-if="isAuthenticated" src="../assets/logout.png" alt="" title="Logout" @click="logoutUser">
                <label v-if="isAuthenticated" style="text-wrap: nowrap; color: #969696; font-family: sans-serif; font-size: 25px; margin-left:30px; margin-top: 5px;">Logged: {{ username }}</label>
            </div>
            <HexagonButton id="new" :class="{ 'disable': !isAuthenticated || !isAdmin, 'unglow-and-unslide-new': isNewCancel, 'fade-in':isOpenCancel, 'glow-and-slide-new': clickedButton === 'NEW', 'fade-out': clickedButton === 'OPEN' }" label="NEW" backgroundcolor="#151515" :textcolor="isAuthenticated ? 'white' : 'gray'" @click="onNewClick"/>
            <HexagonButton id="open" :class="{ 'disable': !isAuthenticated, 'unglow-and-unslide-open': isOpenCancel, 'fade-in':isNewCancel, 'glow-and-slide-open':clickedButton === 'OPEN', 'fade-out': clickedButton === 'NEW'}" :style="'margin-left:25px'" label="OPEN" backgroundcolor="#151515" :textcolor="isAuthenticated ? 'white' : 'gray'" @click="onOpenClick"/>
            <NewProject v-if="showNewProject" :class="{'fade-in-new-project':isNew, 'fade-out-new-project':isNewCancel}" @cancelNewProject="onNewCancel" />
            <OpenProject v-if="showOpenProject" :class="{'fade-in-open-project':isOpen, 'fade-out-open-project':isOpenCancel}" @cancelOpenProject="onOpenCancel" />
        </div>
    </div>
</template>
  
<script lang="ts">
    import { defineComponent, ref, onMounted  } from "vue"
    import HexagonButton from "../components/HexagonButton.vue";
    import NewProject from "../components/NewProject.vue";
    import OpenProject from "../components/OpenProject.vue";
    import { useRouter } from 'vue-router';
    import { supabase } from "@/supabase";
  
    export default defineComponent ({
        components: {
            HexagonButton,
            NewProject,
            OpenProject
        },
        setup(){
            // URL router
            const router = useRouter();
            
            const isNew = ref<boolean>(false);
            const isOpen = ref<boolean>(false);
            const isNewCancel = ref<boolean>(false);
            const isOpenCancel = ref<boolean>(false);
            const showNewProject = ref<boolean>(false);
            const showOpenProject = ref<boolean>(false);
            const clickedButton = ref<string>("");

            const isAuthenticated = ref(false);
            const isAdmin = ref(false);  
            const username = ref("");

            const email = ref("");
            const password = ref("");            

            // Check if user is logged in
            onMounted(() => {
                checkSession();
            });

            const login = async () => {
                try {
                    const { data, error } = await supabase.auth.signInWithPassword({
                    email: email.value.trim(),
                    password: password.value
                    });
                    if (error) {
                    console.error("Login error:", error.message);
                    return;
                    }
                    // Se correu bem, vamos verificar a sessão
                    await checkSession();
                } catch (err) {
                    console.error("Login failed:", err);
                }
            };

            const checkSession = async () => {
                // Get logged in user
                //const { data: { user } } = await supabase.auth.getUser();
                const { data: { session } } = await supabase.auth.getSession();
                const user = session?.user ?? null;                

                if (user) {
                    const { data: profile, error } = await supabase
                        .from('profiles')
                        .select('username, isadmin, isapproved')
                        .eq('user_id', user.id)
                        .single();

                    if (error || !profile?.isapproved) {
                        await supabase.auth.signOut();
                        isAuthenticated.value = false;
                        return;
                    }

                    isAuthenticated.value = true;
                    username.value = profile.username;
                    isAdmin.value = profile.isadmin;
                } else {
                    isAuthenticated.value = false;
                }
            };

            const logoutUser = async () => {
                await supabase.auth.signOut();
                isAuthenticated.value = false;
                isAdmin.value = false;
                username.value = "";
            };            

            function navToRegister() {
                router.push({path: "/register" });
            }

            function navToAdmin() {
                router.push({path: "/admin" });
            }

            function onNewCancel() {
                isNewCancel.value = true;
                isNew.value = false;
                isOpen.value = false;
                clickedButton.value = "";
                showNewProject.value = false;
                showOpenProject.value = false;
            }

            function onOpenCancel() {
                isOpenCancel.value = true;
                isNew.value = false;
                isOpen.value = false;
                clickedButton.value = "";
                showNewProject.value = false;
                showOpenProject.value = false;
            }

            function onNewClick() {
                if (!isAuthenticated.value || !isAdmin.value) return;

                isNewCancel.value = false;
                isOpenCancel.value = false;
                clickedButton.value = "NEW";
                isNew.value = true;
                isOpen.value = false;
                showOpenProject.value = false;

                setTimeout(() => {
                    showNewProject.value = true;
                }, 500);
            }

            function onOpenClick() {
                if (!isAuthenticated.value) return;

                isNewCancel.value = false;
                isOpenCancel.value = false;
                clickedButton.value = "OPEN";
                isOpen.value = true;
                isNew.value = false;
                showNewProject.value = false;

                setTimeout(() => {
                    showOpenProject.value = true;
                }, 500);
            }

            return { onNewClick, onOpenClick, isNew, isOpen, isNewCancel, isOpenCancel, clickedButton, showNewProject,
                     showOpenProject, onNewCancel, onOpenCancel, navToAdmin, isAdmin, password, login, isAuthenticated,
                     email, navToRegister, username, logoutUser };
        }
    });
</script>
  
<style lang="scss" scoped>
    .main {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        width: 100vw;
        height: 100vh;
        background: #151515;
    }

    .BottomContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;        
        background: inherit;
    }

    .user-area {
        width: 150px;
        height: auto;
        background: linear-gradient(0.25turn, transparent, #262626, transparent);
        position:absolute;
        display: flex;
        align-items: start;
        justify-content: start;
        top: 10px;
        left: 400px;
    }

    .login {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        height: 25px;
    }

    .or-style {
        color: #767676;    
        margin: 10px;
    }

    .user-area img {
        opacity: 70%;
        width: 30px;
        height: auto;
        padding: 5px;
    }

    .user-area img:hover {
        background: #464646;
    }

    .TriangleTop {
        z-index: 3;
        --s: 9px; /* control the size*/
        --c1: #070707;
        --c2: #1a1a1a;
  
        --c:#00000000,var(--c1) .5deg 119.5deg,#0000 120deg;
        --g1:conic-gradient(from  60deg at 56.25% calc(425%/6),var(--c));
        --g2:conic-gradient(from 180deg at 43.75% calc(425%/6),var(--c));
        --g3:conic-gradient(from -60deg at 50%   calc(175%/12),var(--c));
        background:
            var(--g1),var(--g1) var(--s) calc(1.73*var(--s)),
            var(--g2),var(--g2) var(--s) calc(1.73*var(--s)),
            var(--g3) var(--s) 0,var(--g3) 0 calc(1.73*var(--s)) 
            var(--c2);
        background-size: calc(2*var(--s)) calc(3.46*var(--s));
    }

    .TriangleVerticalTop{
        width: 400px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        transform: skew(-17deg) translateX(-50%);
        background: inherit;
    }
    
    .TriangleVerticalLine{
        width: 5px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        transform: skew(-17deg) translateX(190px);
        background-color: rgb(190, 190, 190);
        box-shadow: 0 0 5px white, 0 0 5px white, 0 0 15px white;
    }

    .logo-container {
        padding-top: 50px;
        padding-left: 120px;
        display: inline-block;
        background: inherit;
        border-radius: 10px;
    }

    .logo {
        display: block;
        width: 60%;
        height: auto;
        -webkit-filter: drop-shadow(5px 5px 5px #707070);
        filter: drop-shadow(5px 5px 5px #707070);
    }

    #new, #open {
        opacity: 1;
    }

    @keyframes glow {
        to {
            box-shadow: 0 0 5px white, 0 0 5px white, 0 0 15px white;
        }
    }

    @keyframes unglow {
        to {
            box-shadow: -3px -3px 5px rgba(255,255,255,0.05), 3px 3px 5px rgba(0,0, 0,0.6);
        }
    }

    @keyframes slide-new {
        to {
            transform: translateX(-200px);
        }
    }

    @keyframes slide-open {
        to {
            transform: translateX(-390px);
        }
    }

    @keyframes unslide-new {
        from {
            transform: translateX(-200px);
        }
        to {
            transform: translateX(0px);
        }
    }

    @keyframes unslide-open {
        from {
            transform: translateX(-390px);
        }
        to {
            transform: translateX(0px);
        }
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fadeOut {
        from {
            opacity: 1;
            box-shadow: none;
        }
        to {
            opacity: 0;
            box-shadow: none;
        }
    }

    .glow-and-fade {
        animation: glow 1.0s forwards, fadeOut 1s forwards 1.0s;
    }

    .glow-and-slide-new {
        z-index: 2;
        pointer-events: none;
        animation: glow 1.0s forwards, slide-new 0.5s forwards;
    }

    .glow-and-slide-open {
        z-index: 2;
        pointer-events: none;
        animation: glow 1.0s forwards, slide-open 1.0s forwards;
    }

    .unglow-and-unslide-new {
        z-index: 2;
        pointer-events: all;
        animation: unglow 1.0s forwards, unslide-new 0.5s forwards;
    }

    .unglow-and-unslide-open {
        z-index: 2;
        pointer-events: all;
        animation: unglow 1.0s forwards, unslide-open 1.0s forwards;
    }

    .fade-out {
        animation: fadeOut 0.5s forwards;
        pointer-events: none;
    }

    .fade-in {
        z-index: 2;
        pointer-events: all;
        animation: fadeIn 0.5s forwards;
    }

    .fade-in-new-project {
        margin-top: 15px;
        z-index: 1;
        position: absolute;
        width:37.5%;
        height: 80%;
        animation: fadeIn 0.5s forwards;
    }

    .fade-out-new-project {
        margin-top: 15px;
        z-index: 1;
        position: absolute;
        animation: fadeOut 0.5s forwards;
    }
    
    .fade-in-open-project {
        margin-top: 15px;
        z-index: 1;
        position: absolute;
        width:37.5%;
        height: 80%;
        animation: fadeIn 0.5s forwards;
    }

    .fade-out-open-project {
        margin-top: 15px;
        z-index: 1;
        position: absolute;
        animation: fadeOut 0.5s forwards;
    }

    .disable {
        color: grey;
        pointer-events: none;
    }
</style>
